import { render, staticRenderFns } from "./OpengraphElement.vue?vue&type=template&id=5a3c71ac&scoped=true&"
import script from "./OpengraphElement.vue?vue&type=script&lang=js&"
export * from "./OpengraphElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c71ac",
  null
  
)

export default component.exports